import React, { useEffect } from 'react';

import { useSetRecoilState } from 'recoil';

import SystemErrorContents from '@/components/MessageDialog/SystemErrorContents';
import { messageDialogSelector } from '@/recoil/selectors/messageDialogSelector';

/**
 * デバッグ用のシステムエラーダイアログ
 *
 * 表示確認用に、実際のエラーを起こさずにシステムエラーダイアログを開く。
 * 表示条件の判定は呼び出し側（App）で行う。
 */
const DebugErrorDialog: React.FC = () => {
  const setDialogState = useSetRecoilState(messageDialogSelector);

  useEffect(() => {
    setDialogState({
      open: true,
      title: 'システムエラー',
      width: 500,
      contents: <SystemErrorContents />,
    });
  }, [setDialogState]);

  return null;
};

export default DebugErrorDialog;
